import { createSelector } from "reselect";
import { selectCreateShipmentForm } from "./selectCreateShipmentForm";

export const selectIsP2P = createSelector(
  selectCreateShipmentForm,
  (createShipmentForm) => createShipmentForm.destination?.label?.length > 0
);
